import styled from "styled-components";

export const BaseTextArea = styled("textarea")(() => {
  return {
    fontFamily: "Poppins",
    fontWeight: 300,
    fontSize: 16,
    lineHeight: "normal",
    padding: "calc(var(--cardPadding))",
    overflow: "hidden",
    outline: "none",
    border: "none",
    backgroundColor: "var(--color-background)",
    borderRadius: ".45rem",
    textOverflow: "ellipsis",
    width: "-webkit-fill-available",
  };
});
